import { render, staticRenderFns } from "./SupportMessageComplete.vue?vue&type=template&id=6290da4a"
import script from "./SupportMessageComplete.vue?vue&type=script&lang=js"
export * from "./SupportMessageComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports